// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"784":"5f4cfa40","797":"58cc7ac1"}[chunkId] + ".chunk.js";
};